import { Component, inject } from "@angular/core";
import { RentVsBuyService } from "./services/rent-vs-buy.service";
import { RvbWinnerBannerComponent } from "./components/winner-banner/rvb-winner-banner.component";
import { RvbMetricRowComponent } from "./components/metric-row/rvb-metric-row.component";
import { RvbControlsPanelComponent } from "./components/controls-panel/rvb-controls-panel.component";
import { RvbChartCardComponent } from "./components/chart-card/rvb-chart-card.component";
import { RvbBreakdownCardsComponent } from "./components/breakdown-cards/rvb-breakdown-cards.component";
import { RvbMethodologyComponent } from "./components/methodology/rvb-methodology.component";

@Component({
    selector: "hs-rent-vs-buy",
    standalone: true,
    imports: [
        RvbWinnerBannerComponent,
        RvbMetricRowComponent,
        RvbControlsPanelComponent,
        RvbChartCardComponent,
        RvbBreakdownCardsComponent,
        RvbMethodologyComponent,
    ],
    templateUrl: "./rent-vs-buy.component.html",
    styleUrl: "./rent-vs-buy.component.scss",
})
export class RentVsBuyComponent {
    protected readonly svc = inject(RentVsBuyService);

    protected readonly chartLabels = () =>
        this.svc.yearResults().map((r) => `Yr ${r.year}`);

    protected readonly costBuyData = () =>
        this.svc.yearResults().map((r) => r.buyNetCost);
    protected readonly costRentData = () =>
        this.svc.yearResults().map((r) => r.rentNetCost);
    protected readonly wealthBuyData = () =>
        this.svc.yearResults().map((r) => r.buyWealth);
    protected readonly wealthRentData = () =>
        this.svc.yearResults().map((r) => r.rentWealth);
}
